// Elegant SVG illustrations for diffuser machines
const DiffuserIllustration = ({ type, className = "" }) => {
  const illustrations = {
    tower: (
      <svg viewBox="0 0 120 200" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Tall tower diffuser - floor standing */}
        <rect x="35" y="180" width="50" height="8" rx="2" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        <rect x="45" y="20" width="30" height="160" rx="4" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        <ellipse cx="60" cy="20" rx="15" ry="4" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        {/* Mist lines */}
        <path d="M55 8 Q60 2 65 8" stroke="#D1C9B8" strokeWidth="1" fill="none" strokeLinecap="round"/>
        <path d="M52 4 Q60 -4 68 4" stroke="#D1C9B8" strokeWidth="1" fill="none" strokeLinecap="round"/>
        {/* Control panel */}
        <rect x="52" y="140" width="16" height="24" rx="2" stroke="#1A1A1A" strokeWidth="1" fill="none"/>
        <circle cx="60" cy="148" r="3" stroke="#1A1A1A" strokeWidth="1" fill="none"/>
        <line x1="55" y1="156" x2="65" y2="156" stroke="#D1C9B8" strokeWidth="1"/>
        <line x1="55" y1="160" x2="65" y2="160" stroke="#D1C9B8" strokeWidth="1"/>
      </svg>
    ),
    tabletop: (
      <svg viewBox="0 0 160 120" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Compact tabletop diffuser */}
        <ellipse cx="80" cy="105" rx="45" ry="8" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        <path d="M45 105 L45 50 Q45 35 60 35 L100 35 Q115 35 115 50 L115 105" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        <ellipse cx="80" cy="35" rx="35" ry="10" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        {/* Mist output */}
        <ellipse cx="80" cy="35" rx="12" ry="4" stroke="#D1C9B8" strokeWidth="1" fill="none"/>
        {/* Mist lines */}
        <path d="M75 22 Q80 15 85 22" stroke="#D1C9B8" strokeWidth="1" fill="none" strokeLinecap="round"/>
        <path d="M72 16 Q80 8 88 16" stroke="#D1C9B8" strokeWidth="1" fill="none" strokeLinecap="round"/>
        {/* Control indicator */}
        <circle cx="80" cy="70" r="4" stroke="#1A1A1A" strokeWidth="1" fill="none"/>
      </svg>
    ),
    scentbox: (
      <svg viewBox="0 0 180 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* HVAC integrated box diffuser */}
        <rect x="20" y="25" width="140" height="60" rx="4" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        {/* Ventilation grilles */}
        <line x1="35" y1="40" x2="35" y2="70" stroke="#D1C9B8" strokeWidth="1"/>
        <line x1="45" y1="40" x2="45" y2="70" stroke="#D1C9B8" strokeWidth="1"/>
        <line x1="55" y1="40" x2="55" y2="70" stroke="#D1C9B8" strokeWidth="1"/>
        <line x1="65" y1="40" x2="65" y2="70" stroke="#D1C9B8" strokeWidth="1"/>
        {/* Display panel */}
        <rect x="100" y="40" width="45" height="30" rx="2" stroke="#1A1A1A" strokeWidth="1" fill="none"/>
        <line x1="108" y1="50" x2="138" y2="50" stroke="#D1C9B8" strokeWidth="1"/>
        <line x1="108" y1="55" x2="130" y2="55" stroke="#D1C9B8" strokeWidth="1"/>
        <circle cx="125" cy="63" r="3" stroke="#1A1A1A" strokeWidth="1" fill="none"/>
        {/* Air flow indicators */}
        <path d="M25 10 L30 20" stroke="#D1C9B8" strokeWidth="1" strokeLinecap="round"/>
        <path d="M35 8 L38 18" stroke="#D1C9B8" strokeWidth="1" strokeLinecap="round"/>
        <path d="M45 10 L46 20" stroke="#D1C9B8" strokeWidth="1" strokeLinecap="round"/>
      </svg>
    ),
    revitalised: (
      <svg viewBox="0 0 140 140" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Smart personal diffuser - cylindrical modern design */}
        <ellipse cx="70" cy="120" rx="30" ry="8" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        <path d="M40 120 L40 60 Q40 40 70 40 Q100 40 100 60 L100 120" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        <ellipse cx="70" cy="40" rx="30" ry="12" stroke="#1A1A1A" strokeWidth="1.5" fill="none"/>
        {/* Smart ring indicator */}
        <ellipse cx="70" cy="40" rx="20" ry="8" stroke="#D1C9B8" strokeWidth="1.5" fill="none"/>
        {/* Mist lines */}
        <path d="M65 22 Q70 14 75 22" stroke="#D1C9B8" strokeWidth="1" fill="none" strokeLinecap="round"/>
        <path d="M62 15 Q70 5 78 15" stroke="#D1C9B8" strokeWidth="1" fill="none" strokeLinecap="round"/>
        {/* Touch control area */}
        <circle cx="70" cy="85" r="12" stroke="#1A1A1A" strokeWidth="1" fill="none"/>
        <circle cx="70" cy="85" r="5" stroke="#D1C9B8" strokeWidth="1" fill="none"/>
        {/* WiFi indicator */}
        <path d="M60 100 Q70 95 80 100" stroke="#D1C9B8" strokeWidth="0.75" fill="none"/>
        <path d="M63 104 Q70 100 77 104" stroke="#D1C9B8" strokeWidth="0.75" fill="none"/>
        <circle cx="70" cy="107" r="1.5" fill="#D1C9B8"/>
      </svg>
    )
  };

  return illustrations[type] || null;
};

export default DiffuserIllustration;
